// AuthContext.js
import React, { createContext, useState, useEffect, useContext } from "react";

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("token")
  );
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [selectedProducts, setSelectedProducts] = useState([]);

  useEffect(() => {
    // Check token validity here and update isAuthenticated accordingly
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);
    setIsAuthenticated(!!storedToken);
  }, []);

  const updateToken = (newToken) => {
    setToken(newToken);
    setIsAuthenticated(!!newToken);
    // You can also save the new token to localStorage or a secure storage method here
    localStorage.setItem("token", newToken);
  };

  const clearToken = () => {
    setToken(null);
    setIsAuthenticated(false);
    localStorage.removeItem("token");
  };

  return (
    <AuthContext.Provider
      value={{
        selectedProducts,
        setSelectedProducts,
        isAuthenticated,
        token,
        updateToken,
        clearToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AuthContext);
};

export default AuthProvider;
